@if (showLoader$ | async) {
  <app-content-loader></app-content-loader>
}
@if (isInitialized$ | async) {
  <div class="step-container columns is-desktop" [class.d-none]="showLoader$ | async">
    <app-aside-bar
      [showEvenWithoutStatement]="false"
      [statement]="statement"
      [workFlowController]="workFlowController"
    ></app-aside-bar>
    <div class="main-content__container payment-checkout">
      @if (showSquareLoader$ | async) {
        <app-square-loader></app-square-loader>
      }
      <div [class.d-none]="showSquareLoader$ | async">
        <h1 class="title_42">{{ "CHECKOUT.TITLE" | translate }}</h1>
        <p class="subdesc">{{ "CHECKOUT.DESCRIPTION" | translate }}</p>
        <div class="payment-checkout__content form-content">
          <div class="payment-checkout__stage payment-banner__wrap">
            <app-payment-banner
              [statement]="statement"
              [statementPaymentAmount]="statementPaymentAmount"
              [isPercentageAmount]="statement.isPremiumPackage && statementPaymentAmount.isPercentagePayment"
            ></app-payment-banner>
          </div>
          @if (statement.isStandardPackage) {
            @if (statementPaymentAmount.isFree) {
              <div class="payment-checkout__feedback_banner">
                <img src="../../../assets/svg/feedback.svg" alt="Feedback" />
                <div class="font-size-20 text-muted">
                  {{ "CHECKOUT.CLIENT_FEEDBACK" | translate }}
                </div>
              </div>
            }
            @if (statement.isPremiumPackageAvailable) {
              <div class="payment-checkout__change_package">
                <div class="title-section">
                  <h3 class="title_24">{{ "CHECKOUT.SELECT_STEUER_TITLE" | translate }}</h3
                  ><app-more-info-tooltip
                    [showText]="false"
                    [titleTooltip]="'CHECKOUT.STEUER_TOOLTIP_TITLE'"
                    [contentTemplateRef]="premiumPackageTooltipTemplate"
                  ></app-more-info-tooltip>
                  <ng-template #premiumPackageTooltipTemplate>
                    <app-tooltip-template-package-info
                      [isPremiumPackage]="true"
                      [isPackageBenefits]="true"
                      [isHowDoesItWork]="true"
                      [standardAmount]="statementPaymentAmount.standardAmountTotal"
                      [premiumAmount]="statementPaymentAmount.premiumAmountTotal"
                      [currencySymbol]="statementPaymentAmount.currencySymbol"
                    >
                    </app-tooltip-template-package-info> </ng-template
                ></div>
                <div class="desc_checkout_change" [innerHTML]="'CHECKOUT.CHANGE_TO_STEUER_DESC' | translate"></div>
                <button class="btn btn--primary select-premium" (click)="setPremiumPackage()">
                  {{ "CHECKOUT.SELECT_STEUER" | translate }}
                </button>
              </div>
            }
          }
          @if (
            (statement.isPremiumPackage &&
              !statementPaymentAmount.isPercentagePayment &&
              !statementPaymentAmount.shouldBeIndividualService) ||
            (statement.isStandardPackage && statementPaymentAmount.standardAmountTotal)
          ) {
            <div class="payment-checkout__coupon_code">
              @if (!showCoupon && !couponCode) {
                <div class="payment-checkout__coupon_code_check" (click)="showCoupon = true">
                  {{ "CHECKOUT.COUPON_CODE_CHECK" | translate }}
                </div>
              }
              @if (showCoupon || couponCode) {
                @if (statement) {
                  <div class="payment-checkout__coupon_form">
                    <app-form-input
                      class="w-100"
                      [placeholder]="'INPUT.COUPON_CODE.PLACEHOLDER'"
                      (modelChange)="couponChanged()"
                      [(model)]="couponCode"
                      [disableLabel]="true"
                      [shouldRenderErrors]="true"
                      [iconSrc]="couponSuccess ? '../../../assets/svg/checkout_check.svg' : null"
                      [errors]="couponError"
                    >
                    </app-form-input>
                    <button (click)="addCode()" class="btn_sm ml-1">
                      {{ "CHECKOUT.USE_COUPON" | translate }}
                    </button>
                  </div>
                }
              }
            </div>
          }
          @if (statement.isStandardPackage) {
            <div class="payment-checkout__order">
              <h3 class="title_24">
                {{ "CHECKOUT.YOUR_ORDER_TITLE" | translate }}
              </h3>
              <div class="payment-checkout__order_wrap">
                <ul class="payment-checkout__order_list">
                  <li>
                    <div class="payment-checkout__order_list_title">
                      {{ "CHECKOUT.ORDER_LIST_STANDARD_NETTO" | translate }}
                    </div>
                    <div class="payment-checkout__order_list_value">
                      {{ statementPaymentAmount.currencySymbol }}
                      {{ statementPaymentAmount.standardNet | number: "1.2-2" }}
                    </div>
                  </li>
                  <li>
                    <div class="payment-checkout__order_list_title">
                      {{ "CHECKOUT.ORDER_LIST_VAT" | translate }} ({{ statementPaymentAmount.vatPercentFormatted }})
                    </div>
                    <div class="payment-checkout__order_list_value">
                      {{ statementPaymentAmount.currencySymbol }}
                      {{ statementPaymentAmount.standardAmountVat | number: "1.2-2" }}
                    </div>
                  </li>
                  <li>
                    <div class="payment-checkout__order_list_title">
                      <b>{{ "CHECKOUT.ORDER_LIST_TOTAL" | translate }}</b>
                    </div>
                    <div class="payment-checkout__order_list_value">
                      <b
                        >{{ statementPaymentAmount.currencySymbol }}
                        {{ statementPaymentAmount.standardAmountTotalFormatted(couponSuccess ? coupon : null) | number: "1.2-2" }}</b
                      >
                    </div>
                  </li>
                  @if (coupon && couponSuccess && statementPaymentAmount.standardAmountTotalBase) {
                    <li>
                      <div class="payment-checkout__order_list_title">
                        {{ "CHECKOUT.ORDER_LIST_COUPON" | translate }}
                      </div>
                      <div class="payment-checkout__order_list_value">
                        - {{ statementPaymentAmount.currencySymbol }}
                        {{ coupon.amount(statementPaymentAmount.standardAmountTotalBase) | number: "1.2-2" }}
                      </div>
                    </li>
                  }
                </ul>
                <div class="payment-checkout__customer_data">
                  <p>
                    <b>{{ "CHECKOUT.CUSTOMER_PERSONAL_DATA" | translate }}</b>
                  </p>
                  <p>
                    {{ statement.getFullname() }}
                  </p>
                  <p> {{ statement.street }} {{ statement.houseNumberWithSupplement }} </p>
                  @if (statement.additionalAddressInfo) {
                    <p>
                      {{ statement.additionalAddressInfo }}
                    </p>
                  }
                  <p> {{ statement.postalCode }} {{ statement.city }} </p>
                  <p>
                    {{ dataSelects.getCountryName(statement.country) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="payment-checkout__stage flex_box">
              <div class="payment-checkout__payments">
                @if (!statementPaymentAmount.isFree) {
                  <h3 class="title_24">
                    {{ "CHECKOUT.PAYMENT_DETAILS" | translate }}
                  </h3>
                  <div class="payment-checkout__payments_wrap">
                    <mat-radio-group name="client_type" [(ngModel)]="selectedPaymentType" class="pay_grid">
                      @for (choice of paymentChoices; track choice) {
                        <mat-radio-button [value]="choice.platform" class="pay_btn">
                          <div class="icon_img_wrap">
                            <img
                              class="icon_img"
                              [src]="choice.ico"
                              [alt]="choice.name"
                              [ngClass]="{ klarna: choice.platform === paymentPlatforms.klarna }"
                            />
                          </div>
                          <span class="payment_name">{{ choice.name }}</span>
                          <img src="../../../assets/svg/checkout_check.svg" class="check_icon" alt="Checked" />
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                }
                @if (!showAllPaymentsMethod && showPaymentsButton) {
                  <div class="all_payments_button_wrap">
                    <button class="btn btn--primary all_payments" (click)="showAllPayments()">
                      {{ "CHECKOUT.SHOW_ALL_PAYMENT_METHODS" | translate }}
                    </button>
                  </div>
                }
                @if (showSelectedPaymentError) {
                  <div class="alert-box" id="selectedPaymentAlertBox">
                    {{ "CHECKOUT.PAYMENT_NOT_SELECTED" | translate }}
                  </div>
                }
              </div>
            </div>
          }
          @if (statement.isPremiumPackage && !statementPaymentAmount.shouldBeIndividualService) {
            <div class="payment-checkout__order">
              <h3 class="title_24">
                {{ "CHECKOUT.YOUR_ORDER_TITLE" | translate }}
              </h3>
              <div class="payment-checkout__order_wrap">
                <ul class="payment-checkout__order_list">
                  <li>
                    <div class="payment-checkout__order_list_title">
                      {{ "CHECKOUT.ADVISER_FEE" | translate }}
                    </div>
                    <div class="payment-checkout__order_list_value">
                      {{ statementPaymentAmount.taxAdvisorFee | number: "1.2-2" }}
                      {{ statementPaymentAmount.currencySymbol }}
                    </div>
                  </li>
                  <li>
                    <div class="payment-checkout__order_list_title">
                      {{ "CHECKOUT.TAXANDO_FEE" | translate }}
                    </div>
                    <div class="payment-checkout__order_list_value">
                      {{ statementPaymentAmount.taxandoFee | number: "1.2-2" }}
                      {{ statementPaymentAmount.currencySymbol }}
                    </div>
                  </li>
                  <li>
                    <div class="payment-checkout__order_list_title">
                      {{ "CHECKOUT.NET_SUM" | translate }}
                    </div>
                    <div class="payment-checkout__order_list_value">
                      {{ statementPaymentAmount.premiumNet | number: "1.2-2" }}
                      {{ statementPaymentAmount.currencySymbol }}
                    </div>
                  </li>

                  <li>
                    <div class="payment-checkout__order_list_title">
                      {{ "CHECKOUT.VAT_PLUS" | translate }} {{ statementPaymentAmount.vatPercentFormatted }}
                    </div>
                    <div class="payment-checkout__order_list_value">
                      {{ statementPaymentAmount.taxandoFeeVat | number: "1.2-2" }}
                      {{ statementPaymentAmount.currencySymbol }}
                    </div>
                  </li>
                  <li>
                    <div class="payment-checkout__order_list_title">
                      <b class="not-bolded">{{ "CHECKOUT.FORECAST_AMOUNT" | translate }}</b>
                    </div>
                    <div class="payment-checkout__order_list_value not-bolded">
                      <b class="not-bolded">
                        {{ statementPaymentAmount.premiumAmountTotalFormatted(couponSuccess ? coupon : null) | number: "1.2-2" }}
                        {{ statementPaymentAmount.currencySymbol }}</b
                      >
                    </div>
                  </li>
                  <li>
                    @if (statementPaymentAmount.isPercentagePayment) {
                      <div class="payment-checkout__order_list_title">
                        <b class="bolded">{{ "CHECKOUT.PAYABLE_AFTER_REFUND" | translate }}</b>
                      </div>
                    } @else {
                      <div class="payment-checkout__order_list_title">
                        <b class="bolded">{{ "CHECKOUT.PAYABLE_BEFORE_SUBMISSION" | translate }}</b>
                      </div>
                    }
                  </li>

                  @if (coupon && couponSuccess && statementPaymentAmount.premiumAmountTotalBase) {
                    <li>
                      <div class="payment-checkout__order_list_title">
                        {{ "CHECKOUT.ORDER_LIST_COUPON" | translate }}
                      </div>
                      <div class="payment-checkout__order_list_value">
                        - {{ statementPaymentAmount.currencySymbol }}
                        {{ coupon.amount(statementPaymentAmount.premiumAmountTotalBase) | number: "1.2-2" }}
                      </div>
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
        </div>
        <div
          class="payment-checkout__regulations"
          [class.pt-0]="statement.isPremiumPackage && statementPaymentAmount.shouldBeIndividualService"
        >
          <app-payment-regulations
            [statement]="statement"
            [termRegulationsIsChecked]="termRegulationsIsChecked$ | async"
            [termRealDataIsChecked]="termRealDataIsChecked$ | async"
            (clickTermRegulations)="clickTermRegulations($event)"
          ></app-payment-regulations>
        </div>
        @if (errors?.length) {
          @if (!errors[0].package) {
            <div class="alert-box">{{ this.errors[0] }}</div>
          }
        }
      </div>
    </div>
    <app-tools-bar [statement]="statement" [buttons]="buttons"></app-tools-bar>
  </div>
}
